import { render, staticRenderFns } from "./ListAndAddPackage.vue?vue&type=template&id=50f87a22&"
import script from "./ListAndAddPackage.vue?vue&type=script&lang=js&"
export * from "./ListAndAddPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports